import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {NgSelectModule} from "@ng-select/ng-select";
import {FormsModule} from "@angular/forms";
import {
  AdminAutocompleteInputComponent
} from "./components/admin-autocomplete-input/admin-autocomplete-input.component";
import {
  ContactPersonsTableComponent
} from "./components/contact-persons-table/contact-persons-table.component";

@NgModule({
  declarations: [
    AdminAutocompleteInputComponent,
    ContactPersonsTableComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    NgSelectModule,
    FormsModule
  ],
  providers: [],
  exports: [
    AdminAutocompleteInputComponent,
    ContactPersonsTableComponent
  ]
})

export class AdminsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapAdminsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AdminsModule);
};

export const downgradedAdminsModule = downgradeModule(bootstrapAdminsModule);
